module.exports = __webpack_public_path__ + "static/media/OnlineOrdersAndAdvDelivery.64d88ac7.png";